<template>
  <section class="waypoints-list">
    <h1 class="metadata-form__header">Selected waypoints</h1>
    <div class="waypoints-list__wrapper">
      <ul>
        <draggable v-model="tags">
          <div v-for="(tag, index) in tags" :key="tag.id + index">
            <waypoints-list-item v-if="getSelectedWaypoint(tag)" :waypoint="getSelectedWaypoint(tag)"/>
          </div>
        </draggable>
      </ul>
    </div>
  </section>
</template>

<script>
import { mapState } from 'vuex'
import waypointsListItem from './waypointsListItem'
import draggable from 'vuedraggable'

export default {
  name: 'waypointsList',

  components: {
    'waypoints-list-item': waypointsListItem,
    'draggable': draggable
  },

  computed: {
    ...mapState(['keyFrame', 'video']),

    tags: {
      get: function () {
        return this.video.tags
      },

      set: function (value) {
        this.$store.commit('updateTags', value)
      }
    }
  },

  methods: {
    getSelectedWaypoint: function (tag) {
      return this.keyFrame.selectedWaypoints.find(swp => {
        return swp.tag === tag
      }) || false
    }
  }
}
</script>
